import React from 'react';
import Accordion from './Accordion';

const Faqs = () => {


  

 const faqData = [
    {
        question: "How do I book a cab with Meghana Cab?",
        answer: "Booking is easy—call Meghana Cab at +91 9075462128 or visit our website for instant online reservations."
    },
    {
        question: "What types of cabs do you offer?",
        answer: "We offer a wide range of vehicles including hatchbacks, sedans, Ertiga, SUVs, Innova Crysta, and tempo travellers."
    },
    {
        question: "Are your cab services available 24/7?",
        answer: "Yes, Meghana Cab operates 24/7 to ensure convenient travel at any time of day or night."
    },
    {
        question: "Do you provide both one-way and round-trip services?",
        answer: "Absolutely! We offer one-way, round-trip, and outstation cab services based on your travel needs."
    },
    {
        question: "What’s included in the fare?",
        answer: "Our fare typically includes fuel charges, tolls, and driver fees. Parking or waiting charges may apply if applicable."
    },
    {
        question: "Can I request stopovers during the trip?",
        answer: "Yes, we allow planned stopovers for meals, sightseeing, or breaks. Just inform us during booking or let the driver know."
    },
    {
        question: "Is last-minute booking available?",
        answer: "Yes, we accept urgent and last-minute bookings based on vehicle availability. Call us for quicker arrangements."
    },
];

  return (

<>
<section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>Faqs</h1>
                    </div>
                </div>
            </section>


 <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>

    
  

</>
  );
};

export default Faqs;